export const fmtMoney = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(n || 0));

// TZ-safe today as YYYY-MM-DD in the user's LOCAL timezone.
// Avoids the off-by-one when crossing midnight relative to UTC.
export const todayISO = (offsetDays = 0) => {
  const d = new Date();
  d.setDate(d.getDate() + offsetDays);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

// Convert a local Date object to its local YYYY-MM-DD string (no UTC conversion).
export const dateToISO = (d) => {
  if (!(d instanceof Date) || Number.isNaN(d.getTime())) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];
const MONTH_NAMES_SHORT = MONTH_NAMES.map((m) => m.slice(0, 3));

// Format date strings WITHOUT going through Date() so YYYY-MM-DD never gets shifted by UTC.
// Accepts:
//   - "YYYY-MM-DD" (preferred, used everywhere for service/issue dates)
//   - ISO strings like "YYYY-MM-DDTHH:mm:ss..." (uses the date part only)
//   - Falsy → "—"
export const fmtDate = (d, { long = false } = {}) => {
  if (!d) return "—";
  const s = String(d).trim();
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) {
    const year = Number(m[1]);
    const monthIdx = Number(m[2]) - 1;
    const day = Number(m[3]);
    if (monthIdx >= 0 && monthIdx < 12) {
      const monthName = (long ? MONTH_NAMES : MONTH_NAMES_SHORT)[monthIdx];
      return `${monthName} ${day}, ${year}`;
    }
  }
  // Last-resort: a non-date-only string. Render best-effort but DO NOT shift by tz.
  try {
    const dt = new Date(s);
    if (Number.isNaN(dt.getTime())) return s;
    return dt.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch { return s; }
};

export const statusTone = (s) => {
  const map = {
    Paid: "secondary", Completed: "secondary", Approved: "secondary", Won: "secondary", Received: "secondary",
    Sent: "primary", "Estimate Sent": "primary", "In Progress": "primary", Confirmed: "primary", Contacted: "primary",
    Draft: "muted", New: "muted", Pending: "accent", "Estimate Scheduled": "accent",
    Declined: "destructive", Lost: "destructive", Cancelled: "destructive", Expired: "destructive", Overdue: "destructive",
    Available: "secondary", "In Use": "primary", "In Maintenance": "accent",
  };
  return map[s] || "muted";
};
